import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchLeadersQualifications = (params = {}) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  let URL = `${sport}/o/${organizationId}/statistics/leaders/criteria`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["leadersQualification", sport, organizationId, JSON.stringify(params)],
    queryFn: async () => {
      const result = await fetchData({
        url: URL,
      });
      return result?.data || [];
    },
  });
};
